import type { FaireProductEntity } from "../../entity_types/product";

export const p_5t74v6b4mk: FaireProductEntity = {
  token: "p_5t74v6b4mk",
  type: "product",
  name: "3pk Mini Neon Stress Ball (Sensory)",
  brandToken: "b_r52w2qo7l3",
  brandName: "USA Toyz",
  imageUrl:
    "https://cdn.faire.com/fastly/3c724f8dbeedaebb75ec20e9a847adc324f57397ccef97ba17cbb14a6072f09e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/67055d12404bea665285371d569e4bf2bc0937078635150969e51e00a1ae3425.png",
    "https://cdn.faire.com/fastly/5903c52f3932da23ee8a8cd87147e15ed381f0cd8e6af48e91e5bd1231793be2.jpeg",
    "https://cdn.faire.com/fastly/0faecda96f34a9ec5d76ae86e7d2ecc4397b58e7be42495bf1b441ff6d68109d.jpeg",
    "https://cdn.faire.com/fastly/79117c51e36a9282d60dac88c9d0db2c9c409ae79c046bf813d51311a8566a94.jpeg",
    "https://cdn.faire.com/fastly/9feb289b130811df4cbf4dd9bd19b173443b1c34da6d9a63e3836d58fc1854e4.jpeg",
    "https://cdn.faire.com/fastly/c36b9b845b7f5cc0009eece6d75acf31282930f18c92195b19ece53e5e054a4a.jpeg",
    "https://cdn.faire.com/fastly/687f3efb91d1238b9824ef5c667f3e48e6dd9f37110345b1879be2281a15db01.png",
  ],
  priceDollars: 7.5,
  description:
    "These vibrant stress balls come in three eye-catching neon colors, perfect for adding a splash of fun to your stress relief routine. Designed for squeezing, squishing, and stretching, these squeeze balls are the ideal companions for easing anxiety and tension throughout your day. Crafted from high-quality, non-toxic materials, these neon squeeze balls are safe, durable, and built to last. Their compact size makes them easy to carry with you wherever you go, ensuring you have stress relief at your fingertips anytime, anywhere.\n\nWhether you're at home, in the office, or on the go, these neon squeeze balls are a fun and effective way to manage stress. They also make a great gift for friends, family, or anyone who loves bright and playful stress relief toys.\n\n• High-Quality Material: Made from durable, non-toxic, and safe materials for long-lasting use.\n• Stress Relief: Perfect for squeezing, squishing, and stretching to help reduce stress and anxiety.\n• Portable Size: Easy to carry in your bag,",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:40.848Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
